import * as PIXI from "pixi.js";
import Layers from "../../../../../../../src/layers/Layers";
import DrawingManagerRendererFactory from "./DrawingManagerRendererFactory";
import { Coord } from "../../../../../../../src/types/Interface";
import { DrawingTool } from "../../../types/Enum";
import { DrawingElmType, DrawingExtraType, DrawingType } from "../../../types/Type";
import { DrawingElmInt, DrawingInt } from "../../../types/Interface";


export default class DrawingManagerRenderer {
  private Layers = Layers.getInstance();
  private drawings: DrawingInt[] = [];
  private drawing?: DrawingElmInt;
  private selectedTool!: DrawingTool;
  private bg!: PIXI.Graphics;
  private drawingColor: number = 0x000000;

  constructor() {

  }

  public getBg = () => this.bg;
  public clearBg = () => DrawingManagerRendererFactory.destroyDrawing(this.bg);
  public drawLine = (sCoord: Coord, eCoord: Coord) => this.drawing.graph.draw(sCoord, eCoord);
  public pushGraph = (graph: DrawingType) => this.drawings.push({ graph, id: Date.now() });
  public getDrawing = () => this.drawing;
  public setSelectedTool = (s: DrawingTool) => this.selectedTool = s;
  public initializePencilLine = () => this.addDrawing(DrawingManagerRendererFactory.createPencilLine(this.drawingColor));
  public initializeLine = () => this.addDrawing(DrawingManagerRendererFactory.createLine(this.drawingColor, this.selectedTool));
  public setDrawingColor = (color: number) => this.drawingColor = color;
  public clearDrawing = () => this.drawing = null;
  public drawBg() {
    this.clearBg();
    this.bg = this.Layers.UI.addChild(new PIXI.Graphics);
    DrawingManagerRendererFactory.drawBg(this.bg);
    return this.bg;
  };
  public delLastDrawing(): number {
    const d = this.drawings.pop();
    if (d) {
      DrawingManagerRendererFactory.destroyDrawing(d.graph);
      return d.id
    }
    return null
  };
  public addPoint(coord: Coord) {
    const drawing = DrawingManagerRendererFactory.createPoint(this.selectedTool, coord, this.drawingColor);
    this.addDrawing(drawing);
    this.Layers.UI.addChild(drawing);
  };
  public clearAll(): void {
    this.drawings.forEach(d => DrawingManagerRendererFactory.destroyDrawing(d.graph));
    this.drawings = [];
  };
  private addDrawing(drawing: DrawingElmType) {
    if (!drawing) {
      return
    }
    this.drawing = { graph: drawing, id: Date.now() };
    this.drawings.push(this.drawing);
  }
  public addExtraDrawing(drwing: DrawingExtraType) {
    if (!drwing) {
      return
    }
    const drawing: { graph: DrawingType, id: number } = { graph: drwing, id: Date.now() };
    this.drawings.push(drawing);
  }
}